'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_signing_SigningApi$$anon$2() {
  this.bWF = null;
  this.bWD = null;
  this.bWE = false;
  this.bWB = null;
  this.bWC = false;
  this.bWG = false;
  this.bWH = false;
  this.bWF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_signing_SigningApi$$anon$2 as $c_Lpresto_pages_signing_SigningApi$$anon$2 };
$p = $c_Lpresto_pages_signing_SigningApi$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_signing_SigningApi$$anon$2;
/** @constructor */
function $h_Lpresto_pages_signing_SigningApi$$anon$2() {
}
export { $h_Lpresto_pages_signing_SigningApi$$anon$2 as $h_Lpresto_pages_signing_SigningApi$$anon$2 };
$h_Lpresto_pages_signing_SigningApi$$anon$2.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bWF;
});
$p.t = (function() {
  if ((!this.bWE)) {
    this.bWD = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("latitude", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("longitude", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("accuracy", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bWE = true;
  }
  return this.bWD;
});
$p.ae = (function() {
  if ((!this.bWC)) {
    this.bWB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().mD, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().mD, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().mD, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bWC = true;
  }
  return this.bWB;
});
$p.w = (function() {
  if ((!this.bWH)) {
    this.bWG = false;
    this.bWH = true;
  }
  return this.bWG;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_signing_SigningApi$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_signing_SigningApi$$anon$2, "presto.pages.signing.SigningApi$$anon$2", ({
  Xd: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_signing_SigningApi$$anon$2 as $d_Lpresto_pages_signing_SigningApi$$anon$2 };
//# sourceMappingURL=presto.pages.signing.-Signing-Api$$anon$2.js.map
